import { styled } from '@mui/material';

export const ContentRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: 16,
  flex: 1,
  minWidth: 0,
  minHeight: 0,
});

export const DetailsPane = styled('div')(({ theme }) => ({
  width: 420,
  minWidth: 320,
  flexShrink: 0,
  minHeight: 0,
  borderLeft: `1px solid ${theme.palette.novotalk.$resourcesTableBorderColor}`,
  paddingLeft: 16,
  display: 'flex',
}));

export const DetailsBody = styled('div')({
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  overflowX: 'auto',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  '& > *': {
    flexShrink: 0,
  },
  '& textarea': {
    flexShrink: 0,
  },
});
